module.exports = __webpack_public_path__ + "img/lg_no_ring.1600faff.png";